module.exports = __webpack_public_path__ + "static/media/diamondCertificateImagejpg.60170851.jpg";